import BaseElement from '@/components/purchase/checkout/seat-selection/modal/canvas/BaseElement';
import useNonInteractiveElement from '@/hooks/useNonInteractiveElement';
import type {
  FloorPlanIconsDTO,
  InternalDTO,
  SignDTO,
} from '@/types/dto/agent';
import { getElementTypeId, getOrientationConfig } from '@/utils/seatSelection';
import Konva from 'konva';
import React from 'react';
import { Image } from 'react-konva';

interface NonInteractiveElementProps {
  element: SignDTO | InternalDTO;
  floorPlanIcons: FloorPlanIconsDTO;
  canvasHeight: number;
  xOffset?: number;
  yOffset?: number;
}

const NonInteractiveElement: React.FC<NonInteractiveElementProps> = ({
  element,
  floorPlanIcons,
  canvasHeight,
  xOffset = 0,
  yOffset = 0,
}) => {
  const orientationId = element.orientation?.id;
  const typeId = getElementTypeId(element, floorPlanIcons);
  const { image } = useNonInteractiveElement({
    elementId: element.elementId,
    floorPlanIcons,
  });

  if (!image || !typeId) return null;

  const orientationConfig = getOrientationConfig(typeId, orientationId);
  const elemOffsetX = orientationConfig.elementOffset.x;
  const elemOffsetY = orientationConfig.elementOffset.y;
  const konvaImage = new Konva.Image({
    image,
    width: image.width,
    height: image.height,
    offsetX: image.width / 2,
    offsetY: image.height / 2,
    rotation: orientationConfig.degrees,
  });

  return (
    <BaseElement
      coordinates={element.coordinates}
      canvasHeight={canvasHeight}
      xOffset={xOffset}
      yOffset={yOffset}
    >
      <Image
        image={image}
        width={image.width}
        height={image.height}
        offsetX={image.width / 2}
        offsetY={image.height / 2}
        x={konvaImage.x() + elemOffsetX}
        y={konvaImage.y() + elemOffsetY}
        rotation={konvaImage.rotation()}
      />
    </BaseElement>
  );
};

export default NonInteractiveElement;
